import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { ResponsiveDirective } from 'projects/qo-commons/src/directives/responsive';
import { Subject } from 'rxjs';
import { EventType } from 'src/app/core/models/EventType';
import { Poster, Posters } from './poster-list.data';

@Component({
    selector: 'qo-poster-list',
    templateUrl: './poster-list.component.html',
    imports: [CommonModule, ResponsiveDirective]
})
export class PosterListComponent implements OnDestroy {

    MAX_NB_POSTERS = 10;

    @Input() multiline: boolean = false;
    @Input() type?: EventType;

    mainPosters: Poster[] = [];
    secondaryPosters: Poster[] = [];

    nbPostersToDisplay: number = 4;

    constructor(breakpointObserver: BreakpointObserver) {
        breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large])
            .subscribe(state => {
                if (state.breakpoints[Breakpoints.XSmall]) this.nbPostersToDisplay = 4;
                else if (state.breakpoints[Breakpoints.Small]) this.nbPostersToDisplay = 5;
                else if (state.breakpoints[Breakpoints.Medium]) this.nbPostersToDisplay = 6;
                else if (state.breakpoints[Breakpoints.Large]) this.nbPostersToDisplay = 8;
                else this.nbPostersToDisplay = 9;
            });

        const elligiblePosters = Posters
            .filter(x => !this.type || x.types.includes(this.type))
            .map(x => ({ value: x, random: Math.random() }))
            .sort((a, b) => a.random - b.random)
            .map(x => x.value);
        this.mainPosters = elligiblePosters.slice(0, this.MAX_NB_POSTERS);
        this.secondaryPosters = elligiblePosters.slice(this.MAX_NB_POSTERS, this.MAX_NB_POSTERS * 2);
    }

    private $destroy = new Subject<boolean>();
    ngOnDestroy(): void {
        this.$destroy.next(true);
        this.$destroy.complete();
    }
}
